import _ from 'lodash';
import React from 'react';
import { NavLink } from 'react-router-dom';

import AddMemberModal from '../add-member-modal';
import AddBandModal from 'client/shared/components/add-band-modal';
import ArtistSignUpForm from './artist-sign-up-form';

class SignUpButton extends React.Component {
	render () {
		const { modalType = 'member' } = this.props;
		const isMember = modalType === 'member';
		const modalContentLabel = isMember ? 'Member Sign Up' : 'Artist Sign Up';

		if (isMember) {

			return (
				<AddMemberModal
					buttonLabel="Sign Up With Email"
					buttonClassName="button neo sign-up"
					modalContentLabel={ modalContentLabel }
					modalClassName={{
						base: 'modal',
						afterOpen: 'modal-after-open',
						beforeClose: 'modal-before-close'
					}}
					modalOverlayClassName={{
						base: 'modal-overlay',
						afterOpen: 'modal-overlay-after-open',
						beforeClose: 'modal-overlay-before-close'
					}} />
			);
		}

		return (
			// <NavLink
			// 	data-ta="addBandBtn"
			// 	to="/sign-up/artists/form"
			// 	className="button hollow secondary"
			// >
			// 	Sign Up With Email
			// </NavLink>

			// <a
			// data-ta="addBandBtn"
			// href="/main#artist-sign-up"
			// className="button neo login"
			// >
			// Sign Up With Email
			// </a>

			<button
				data-ta="addBandBtn"
				onClick={ () => window.location.hash = "artist-sign-up" }
				className="button neo sign-up"
			>
				Sign Up With Email
			</button>



			// <AddBandModal
			// 	buttonLabel="Sign Up With Email"
			// 	buttonClassName="button neo sign-up"
			// 	modalContentLabel={ modalContentLabel }
			// 	modalClassName={{
			// 		base: 'modal',
			// 		afterOpen: 'modal-after-open',
			// 		beforeClose: 'modal-before-close'
			// 	}}
			// 	modalOverlayClassName={{
			// 		base: 'modal-overlay',
			// 		afterOpen: 'modal-overlay-after-open',
			// 		beforeClose: 'modal-overlay-before-close'
			// }} />

		);
	}
};


export default SignUpButton;
